<template>
  <module-link
    link="dashboard"
    :no-underline="true"

    class="u-user-info"
  >
    <span class="u-user-info__wrapper">
      <span class="u-user-info__name p">{{ user.full_name || `` }}</span>
      <span class="u-user-info__role h6">{{ userRole.string || `` }}</span>
    </span>
  </module-link>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Modules
import ModuleLink from 'modules/Link';

// Export
export default {
  name: `module-user-info`,

  // Components
  components: {
    ModuleLink,
  },

  // Data
  computed: {
    ...mapGetters(`auth`, [
      `isAuthenticated`,
      `user`,
      `userRole`,
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// UserInfo.vue?428c4eeb